module.exports = __webpack_public_path__ + "img/restaurant-design.57de3068.svg";